﻿module.exports = [
    'areYouSureModal', 
    'loggingOutModal', 
    'messageModal',
    widgetModalsService
];

function widgetModalsService(
    areYouSureModal, 
    loggingOutModal,
    messageModal
) {

    var service = {
        areYouSure: areYouSureModal,
        loggingOut: loggingOutModal,
        message: messageModal
    };

    return service;

}
